import { z } from 'zod';
import { documentIdSchema } from './documents';

export const addBookSchema = z.object({
  url: z.string().trim().min(1, 'Paste a link to an EPUB').max(500, 'That link is too long'),
});
export type AddBookInput = z.infer<typeof addBookSchema>;

export const addedBookStatusSchema = z.enum(['queued', 'importing', 'ready', 'failed', 'removed']);
export type AddedBookStatus = z.infer<typeof addedBookStatusSchema>;

/** A link a reader added, and how it went; only ever shown to that reader. */
export const addedBookSubmissionSchema = z.object({
  id: z.number().int(),
  url: z.string(),
  status: addedBookStatusSchema,
  error: z.string().nullable(),
  title: z.string().nullable(),
  documentId: documentIdSchema.nullable(),
});
export type AddedBookSubmission = z.infer<typeof addedBookSubmissionSchema>;

export const addedBookInfoSchema = z.object({
  id: z.number().int(),
  addedBy: z.string().nullable(),
  canRemove: z.boolean(),
  /** Only for those who can remove the book. */
  sourceUrl: z.string().nullable(),
});
export type AddedBookInfo = z.infer<typeof addedBookInfoSchema>;
